import React, { Fragment } from 'react'
import { Table, TableBody, TableCell, TableContainer,
   TableHead, TableRow, Paper, TablePagination, TextField, Autocomplete, Checkbox} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import TableFooter from '@mui/material/TableFooter';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import { useState } from 'react';
import styled from 'styled-components';
import AMreadonlyrow from '../Assetmaster/AMreadonlyrow';
import AMeditablerow from '../Assetmaster/AMeditablerow';
import { useEffect } from 'react';
import SubCategMaster from './SubCategMaster';
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import { useGetAssetMastersQuery, useAddNewAssetMasterMutation, useUpdateAssetMasterMutation,
   useDeleteAssetMasterMutation } from '../../../features/assetmasterApiSlice/assetmasterApiSlice';
import ExcelDownload from '../../../data/exceldownload';
import {TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Addcategform = styled.form`
  display: flex;
  justify-content: space-between;
  margin:10px;
  align-items:center;
`
const Displaydiv1 = styled.div`

`
const FormEleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items:center;
`

const SubmitButton = styled(CommonButton)`
  height:"40px";
  margin-top:"0px";
  margin-bottom:"0px";
`
const Button2Div =styled.div`
  display: flex;
  justify-content: end;
`
const tableFontSize = 18;

const tarray = (array,data,resultarray=[])=>{
  for(const val of array){
    if(val.Asset.length !== 0){
        for(const key of val.Asset){
            for(const spec of key.Specifications){
              let tempobject ={};        
              tempobject= {...tempobject,"Category":val.Category,"Name":key.Name, [Object.keys(spec)]:spec[Object.keys(spec)] }
              resultarray.push(tempobject);
            }      
        }
      }else{  
        let tempobject ={};
        tempobject= {...tempobject,"Category":val.Category}
        resultarray.push(tempobject);
      }      
  }
  return resultarray;
}

//This is a function which returns true if
// 1. If B is an Array there should be atleast one common element between A & B.
// 2. If B is String the Array A should have one of the element as that string.

const hasCommonElement = (A, B)=> {
  if (Array.isArray(B)) {
    // Check if there is at least one common element between arrays A and B
    return A.some(element => B.includes(element));
  } else if (typeof B === 'string') {
    // Check if array A contains the string B
    return A.includes(B);
  } else {
    // Handle other cases (e.g., B is neither an array nor a string)
    return false;
  }
}

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};


export default function CustomPaginationActionsTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const {
    data: assetmasters,
    // isLoading,
    // isSuccess,
    // isError,
    // error
  } = useGetAssetMastersQuery('assetmasterlist', {
    refetchOnFocus: true,
    refetchOnMountOrArgChange: true
  });
 
  const [addNewAssetMaster
    // , {
    // isLoading:addassetmasterisLoading,
    // isSuccess: addassetmasterisSuccess,
    // isError: addassetmasterisError,
    // error: addassetError
// }
] = useAddNewAssetMasterMutation();

const [updateAssetMaster
  // , {
  // isLoading: updateassetmasterisLoading,
  // isSuccess: updateassetmasterisSuccess,
  // isError: updateassetmasterisError,
  // error: updateassetmasterError
// }
] = useUpdateAssetMasterMutation();

const [deleteAssetMaster
  // , {
  // isSuccess: deleteAssetMasterisSuccess,
  // isError: deleteAssetMasterisError,
  // error: deleteAssetMasterError
// }
] = useDeleteAssetMasterMutation();

  const [newCategData, setNewCategData] = useState({"Category":"","Asset":[]})
  const [assetMasterData, setAssetMasterData] = useState([]);
  const [editFormData, setEditFormData] = useState([]);
  const [categProp, setCategProp]= useState()
  const [editCategory, setEditCategory]=useState(null);
  const [downloadData, setDownloadData] = useState({});
  const [subCateg, setSubCateg] = useState({});
  const [subCategPage, setSubCategPage] = useState(false);
  const [searchData, setSearchData] = useState({
    Category:"",
    Asset:[]
  });

  useEffect(() =>{
   let tempdata = assetmasters? Object.values(assetmasters?.entities):[];
   setAssetMasterData(tempdata);
   setEditFormData(tempdata);
   },[assetmasters])


     // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - assetMasterData.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onClickAddSubCateg = (e,k) => {
    setCategProp(assetMasterData[k].Category)
    setSubCategPage(true)       
  }

  const onChangeNewCateg = (event) =>{
    let tempNewCateg = {...newCategData};
    tempNewCateg.Category = event.target.value;
    setNewCategData(tempNewCateg);
  }
 
// console.log(searchData)
  const onSubmitNewCateg = async (event) => {
    event.preventDefault();
    try{     
      let bodyobject ={...newCategData};
      console.log(bodyobject)    
      const found = Object.values(assetmasters.entities).some(el => el.Category === bodyobject.Category);
   if(!found){
      const res = await addNewAssetMaster(bodyobject) ;
      }else{
        alert(`The Category "${bodyobject.Category}" already exists.`)
      }
    } catch(err){}
    setNewCategData({"Category":"","Asset":[]})
  }

  const onChangeEditCateg = (e,k,id) => {
    let tempEditFormData = structuredClone(editFormData);
    let tempIndex = tempEditFormData.findIndex(x => x._id === id )
    if(e.target.name === "Category"){
      tempEditFormData[tempIndex].Category = e.target.value;
      setEditFormData(tempEditFormData);
    }
    if(e.target.name === "Asset"){
      tempEditFormData[tempIndex].Asset[subCateg[`subcateg${editCategory-1}`]?.index].Name = e.target.value;
      setEditFormData(tempEditFormData);
    }
  }

  const onClickEdit = (e,k)=>{
    setEditCategory(k+1);
  }

  console.log(editFormData)

  const handleEditFormSubmit = async (event) =>{
    console.log("Entered")
    event.preventDefault();
    try{
    setEditCategory(null);
    let id  = assetMasterData[((page)*(rowsPerPage))+(editCategory-1)].id;
    let body = editFormData.find(x => x.id === id);   
    const response = await updateAssetMaster(body);
    setSubCateg({});
    }catch(err){}
  }
  

  const handleCancelClick = (e,k) => {    
    setEditCategory(null);
    setSubCateg({});
  };

  const handleDeleteClick = async (e,k,id) => {
    let body = {"id":id}
    const result = await deleteAssetMaster(body);
  };
  
  const onChangeSub = (event, newValue, name,k) =>{
    let tempObject = {};
    tempObject = {...tempObject, [name]:{"data":newValue, "index":assetMasterData[k].Asset.map(x=>x.Name).indexOf(newValue)}} 
    setSubCateg(tempObject);
  }

  const onClickBackArrow = () =>{
    setSubCategPage(false);
  }

  const handleSearchChange = (event, newValue, name) =>{
    let tempData = structuredClone(Object.values(assetmasters?.entities));
    let tempSearchData = structuredClone(searchData);
    if(event?.target?.name){
      tempSearchData[event.target.name] = event.target.value;
      setSearchData(tempSearchData);
     }else{
      tempSearchData[name] = newValue
      setSearchData(tempSearchData);
     }
     for(let key in tempSearchData){
      if(typeof tempSearchData[key] === "string" && tempSearchData[key].length){
          tempData = tempData.filter(x=> x[key].toLowerCase().includes(tempSearchData[key].toLowerCase()))
      }
      if (typeof tempSearchData[key] === "object" && tempSearchData[key].length ){
          console.log("Entered2")
          console.log(key)
          console.log(tempData)
          tempData = tempData.filter(x => hasCommonElement(tempSearchData[key], x[key]?.map(y => y.Name)))
          console.log(tempData)
      }
    }
    setAssetMasterData(tempData);
  }

//Setting the download data for excel download.
useEffect(()=>{
  let finalDownloadData = [];
  let finalSortedDownloadData = [];
  const keyOrderArray = ["Category","Asset", "Specification", "Values"]
  let tempDownloadData = structuredClone(tarray(assetMasterData));
  for(let val of tempDownloadData ){
      let tempDoc = {};
      tempDoc = {...tempDoc, "Category": val.Category, "Asset":val.Name, "Specification":Object.keys(val)[2] ,"Values" :Object.values(val)[2]?.join(",") }
      finalDownloadData.push(tempDoc)
    }

    for(let value of finalDownloadData){
        let tempObject = {}
        for(let val of keyOrderArray){
            tempObject = {...tempObject, [val]:value[val]};
        }
        finalSortedDownloadData.push(tempObject);
    }
    setDownloadData(finalSortedDownloadData)
}, [assetMasterData])

   
  return (
    <>
    { !subCategPage ?
    <Displaydiv1>
      <HeadingWrap>
        <Span>Add New Asset Master</Span>
      </HeadingWrap>

    <Addcategform onSubmit={onSubmitNewCateg}>
      <FormEleWrapper>
        <TextField
          id="outlined-basic"
          size='small'
          name='Category'
          onChange={(event) => onChangeNewCateg(event)}
          label="Enter a New Category"
          value={newCategData.Category || ""}
          variant="outlined"
          sx={{backgroundColor:"white", width:"200px", height:"40px"}}
        />
        <SubmitButton type='submit'>Submit</SubmitButton>
      </FormEleWrapper>
      <Button2Div>
          <ExcelDownload data={downloadData} filename={"assetMasterData"} sheetName={"sheet1"}/>
      </Button2Div>  
    </Addcategform>

    <form onSubmit={handleEditFormSubmit}>

    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }} >
      <Table  aria-label="custom pagination table">
      <TableHead>
        <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor}} >
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"5%"}}} align="left" >Sl.No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"5%"}}} align="left" >Category</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"5%"}}} align="left">Asset</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"5%"}}} align="left">Edit</TableCell>
        </TableRow>

        <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
          <TableCell></TableCell>
          <TableCell>
            <TextField sx={{background:"white"}}  name='Category' onChange={handleSearchChange} label="Search Category" size="small"  variant="outlined" />
          </TableCell>
          <TableCell>
            <Autocomplete
                multiple
                id="checkboxes-tags-demo"
                onChange={(event, newValue) => handleSearchChange(event, newValue, "Asset")}
                size="small"
                value={searchData.level}
                options={assetmasters? Object.values(assetmasters?.entities).map(x => x.Asset.map(y=>y.Name)).flat(3).sort():[]}
                disableCloseOnSelect
                getOptionLabel={(option) => String(option)}
                renderOption={(props, option, { selected }) => (
                  <li {...props} style={{ fontSize: '2 rem' }}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 0, marginLeft:0 }}
                      checked={selected}
                    />
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} label="Search Level"  sx={{background:"white", width:"50%"}} />
                )}
                /> 
          </TableCell>
          <TableCell></TableCell>
        </TableRow>

      </TableHead>

      <TableBody>
        {(rowsPerPage > 0
          ? assetMasterData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): assetMasterData
          ).map((row, key) => ( 
            <Fragment key={key*2}>
              {editCategory=== key+1 ?
              
               <AMeditablerow row={row} k={key} subCateg={subCateg} 
                handleCancelClick={handleCancelClick} page={page} rowsPerPage={rowsPerPage}
                editFormData={editFormData} onChangeEditCateg ={onChangeEditCateg}
                tableFontSize={tableFontSize} SubmitButton = {SubmitButton}
               />

                :<AMreadonlyrow row={row} k={key} onClickEdit={onClickEdit} subCateg={subCateg}
                  handleDeleteClick= {handleDeleteClick} onClickAddSubCateg={onClickAddSubCateg}
                  onChangeSub = {onChangeSub} page = {page} rowsPerPage = {rowsPerPage} editCategory={editCategory}
                  tableFontSize={tableFontSize} SubmitButton = {SubmitButton}                            
                />
                 }
            </Fragment>                   
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={assetMasterData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </form>
    </Displaydiv1>:

    <SubCategMaster assetMasterData = {assetMasterData} setAssetMasterData = {setAssetMasterData} categProp={categProp} onClickBackArrow={onClickBackArrow} tarray={tarray} deleteAssetMaster={deleteAssetMaster} assetmasters = {assetmasters} Button2Div={Button2Div} ExcelDownload={ExcelDownload} />
    }    
    </>
  );
}